import React from 'react';
import { useTranslation } from 'react-i18next';
import { Footer } from '@/components/Footer/Footer';
import { PageTopControls } from '@/components/PageTopControls/PageTopControls';
import { EditAdForm } from '@/components/AdForm/EditAdForm';

export const EditAdView = () => {
  const { t } = useTranslation();

  return (
    <>
      <PageTopControls headerTitle={t('pages.new_ad.edit_ad')} isBackRequired />

      <EditAdForm />

      <Footer />
    </>
  );
};
